const Header = () => {
    return (
        <header className="header-wrapper">
            <h1 className="title">HACKER NEWS</h1>
        </header>
    )
}

export default Header;